import React from "react";
import {
  Card,
  CardHeader,
  CardContent,
  makeStyles,
  TextField,
  InputAdornment,
  withStyles,
} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import MenuItem from "@mui/material/MenuItem";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import SearchIcon from "@mui/icons-material/Search";
// import "../../HOC/layout/layout.css";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#24BEB2",
    // padding: "7px 0px 7px 20px",
    // boxShadow: "1px 0px 2px #000",
  },
  title: {
    padding: "4px 20px 4px 0px",
    fontSize: "18px",
    fontFamily: "Dosis",
    fontWeight: 600,
    color:"white"
  },
  cardContent: {
    // paddingBottom: "0px",
  },
}));

const CssTextField = withStyles({
  root: {
    "& .MuiOutlinedInput-input": {
      padding: "7px 5px",
    },
    "& label.Mui-focused": {
      color: "#666666",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#737373",
      },
      "&:hover fieldset": {
        borderColor: "#595959",
      },
    },
  },
})(TextField);

function BoxWrapper(props) {
  const classes = useStyles();
  const {
    boxTitle,
    children,

    cutIcon,
    closeBoxWapper,

    zohoEffitracEnable,
    zohoEffitracFn,
    importToCwsEnableForZoho,
    importToCwsForZoho,

    enableImportToEffTallybutton,
    importToEffiTallyFn,
    colorForMessage,
    ErrorIcon,
    // back button
    backButtonForZohoEnable,
    backButton,
    // export to excel
    exportToExcelEnable,
    exportToExcelFn,
    // raw export button
    rawExportToExcelEnable,
    rawExportToExcelFn,
    // Dropdown
    enableDropdown,
    dropdownHandlerFn,
    dropdownOptions,
    dropdownValue,

    // search textfield
    enableSearchInput,
    searchInputPlaceholder,
    searchInputOnchange,
    // add button
    enableAddButton,
    addButtonLabel,
    addButtonHandlerFn,
  } = props;
  return (
    <div>
      <Card>
        <CardHeader
          classes={{ root: classes.root, title: classes.title }}
          title={boxTitle}
          action={
            <>
              <div
                style={{
                  marginTop: "10px",
                  marginRight: "20px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                {/* SEARCH INPUT FIELD */}
                {enableSearchInput && (
                  <CssTextField
                    id="outlined-basic"
                    variant="outlined"
                    size="small"
                    placeholder={searchInputPlaceholder}
                    onChange={searchInputOnchange}
                    style={{
                      padding: "0px",
                      background: "#fff",
                      borderRadius: "7px",
                      marginRight: "10px",
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon style={{ color: "#ddd" }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                )}

                {/* BACK BUTTON FOR ZOHO */}
                {backButtonForZohoEnable && (
                  <button
                    onClick={backButton}
                    className="button-outlined-primary"
                  >
                    Back
                  </button>
                )}

                {/* ZOHO EFFITRAC BUTTON */}
                {zohoEffitracEnable && (
                  <button
                    onClick={zohoEffitracFn}
                    className="button-outlined-primary"
                  >
                    Zoho
                  </button>
                )}

                {/* IMPORT TO ZOHO */}
                {importToCwsEnableForZoho && (
                  <button
                    onClick={importToCwsForZoho}
                    className="button-outlined-primary"
                  >
                    Import To Cws
                  </button>
                )}

                {/* IMPORT TO EFFITRAC BUTTON */}
                {enableImportToEffTallybutton && (
                  <button
                    onClick={importToEffiTallyFn}
                    className="button-outlined-primary"
                  >
                    import effitrac/tally
                  </button>
                )}

                {/* Add Back Button */}
                {enableAddButton && (
                 <button
                  onClick={addButtonHandlerFn}
                  style={{ backgroundColor: '#1b3cb3', color: 'white' }}
                    className="button-outlined-primary"
                    >
                     {addButtonLabel}
                 </button>
                 )}
                {/* RAW EXPORT TO EXCEL */}
                {rawExportToExcelEnable && (
                  <button
                    onClick={rawExportToExcelFn}
                    className="button-outlined-primary"
                  >
                    raw export <FileDownloadIcon style={{ fontSize: "20px" }} />
                  </button>
                )}

                {/* NORMAL EXPORT TO EXCEL */}
                {exportToExcelEnable && (
                  <button
                    className="button-outlined-primary"
                    onClick={exportToExcelFn}
                  >
                    export <FileDownloadIcon style={{ fontSize: "20px" }} />
                  </button>
                )}

                {/* DROPDOWN  */}
                {enableDropdown && (
                  <TextField
                    id="outlined-select-currency"
                    select
                    label={props.dropdownLabel ?? ""}
                    value={dropdownValue}
                    onChange={dropdownHandlerFn}
                    size="small"
                    style={{ width: "100px" }}
                  >
                    {dropdownOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                )}

                {/* CLOSE ICON */}
                {cutIcon && (
                  <button
                    className="close-icon-button"
                    onClick={closeBoxWapper}
                  >
                    <CloseIcon style={{ color: "red" }} />
                  </button>
                )}
              </div>
            </>
          }
        ></CardHeader>
        <CardContent
          className={classes.cardContent}
          style={{ paddingBottom: "15px" }}
        >
          <div style={{ color: colorForMessage ? colorForMessage : "black" }}>
            {ErrorIcon && ErrorIcon} {children}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export default BoxWrapper;
